import { IAppRoute } from 'interfaces/route';
import { userRoles } from 'interfaces/user';
import { PureComponent } from 'react';

import AccessReport from './Report/Access';
import SLAReport from './Report/SLA';
import UploadReport from './Report/Upload';

export default class ReportsRouter extends PureComponent {
  public static routes: IAppRoute[] = [
    {
      path: '/sla',
      sideDrawer: { display: 'SLA', order: 2 },
      roles: [userRoles.admin, userRoles.sysAdmin, userRoles.holding, userRoles.venturer, userRoles.auditor],
      component: SLAReport
    },
    {
      path: '/access',
      sideDrawer: { display: 'Acesso', order: 3 },
      roles: [userRoles.admin, userRoles.sysAdmin, userRoles.holding, userRoles.venturer, userRoles.auditor],
      component: AccessReport
    },
    {
      path: '/upload',
      sideDrawer: { display: 'Upload', order: 4 },
      roles: [userRoles.admin, userRoles.sysAdmin, userRoles.holding, userRoles.venturer, userRoles.auditor],
      component: UploadReport
    },
  ];

  render() {
    return (this.props.children);
  }
}
